module.exports = __webpack_public_path__ + "static/media/w (22).69e4637e.jpg";